import Tween from "tween.ts";
import Animation from "./Animation";


export default class RotateAnim extends Animation {
	private Anim = Animation.getInstance();
	isStopped = false;
  
	constructor(deltaRad: number, duration: number, onUpdate: (r: number) => void, onComp: () => void, resolve:() => void){
    super();

		const radian = { v: 0 }

		this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

		if(this.Anim.getIsCancelled()) {
      resolve();
      return 
    };

		new Tween.Tween({...radian})
			.to({ v: deltaRad }, duration)
			.easing(Tween.Easing.Linear.None)
			.onUpdate(radianObj => {
			  if(this.isStopped) {
          onComp();
          return
        }
				onUpdate(radianObj.v)
			})
			.onComplete(() => onComp())
			.start()
  }
}